<css-switcher class="px-1 py-1">

    <script>
        import StoreService from '/src/services/store';

        export default {
            async onMounted(props, state) {
                const progetto_id = this.props.progetto_id
                const progetto = await StoreService.fetchProgettoById(progetto_id)
                // Se esiste un file CSS, iniettalo
                if (progetto && progetto.get('css')) {
                    this.injectCss(progetto.get('css').url())
                }
            },

            injectCss(url) {
                // Rimuove eventuali stili precedenti
                const existingLink = document.getElementById('custom-css')
                let current_href = ''
                if (existingLink) {
                    const current_href = existingLink.href
                    if (current_href != url) {
                        existingLink.href = url
                    }
                } else {
                    const link = document.createElement('link')
                    link.id = 'custom-css'
                    link.rel = 'stylesheet'
                    link.type = 'text/css'
                    link.href = url
                    link.media = 'all'
                    document.head.appendChild(link)
                }
            }
        }
    </script>
</css-switcher>
